<template>
    <div class="bank-list">
        <template v-for="(bank, idx) of states.items" :key="idx">
            <BankCard :src="bank.imageUrl" :url="bank.line2"></BankCard>
        </template>
    </div>
</template>
<script>
import BankCard from "./BankCard.vue"

import ConfigManager from "@/config/ConfigManager"
import useDashboardComposable from "@/composables/Dashboard/DashboardComposable"

export default {
    name: 'BankList',
    components: {
        BankCard
    },
    data: function () {
        return {
            banks: []
        }
    },
    emits: ["onLoading", "onLoaded", "onError"],
    setup: function (props, { emit }) {
        return useDashboardComposable(ConfigManager.getDashboardApplyCard(), emit)
    },
}
</script>
